import isoFetch from 'isomorphic-unfetch';
import URL from 'url-parse';

export const fetch = (path, { query, circuitBreaker, ...options } = {}) => {
    const url = new URL(path);
    if (query) {
        url.set('query', { ...query });
    }
    return isoFetch(url, options)
        .then((response) => response)
        .catch((err) => {
            // eslint-disable-next-line no-console
            console.error(err);
            if (options?.circuitBreaker) {
                throw err; // throws err to circuitbreaker
            }
        });
};

export const fetchJSON = async (url, options = {}) => {
    options = {
        // credentials: 'include',
        method: 'GET',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    };

    if (options.method === 'POST' || options.method === 'PUT') {
        // default options.body to empty object
        // if it does not exist
        if (!options.body) {
            options.body = {};
        }

        const { query = {}, search = {}, data = {} } = options;

        // merge all request data options to body for posts
        options.body = JSON.stringify({ ...data, ...query, ...search, ...options.body });
    }

    const response = await fetch(url, options);

    if (options.method === 'PUT') {
        return { statusCode: response.status };
    }

    if (response) {
        const json = await response.json();
        return json;
    }

    return {};
};

export default fetch;
